//start rating component
import React from 'react'
import Tag from '../templates/Tag'

const activeClass = (tag) => {
  if(tag.selected){
    return 'active'
  }
  return ''
}

const backgroundImage = (tag) => {
  let imageSrc = tag.src
  if(tag.selected){
    imageSrc = tag.srcSelected
  }
  return imageSrc
}

class TagHOC extends React.Component {

  render () {
    return (
      <Tag 
        tag={ this.props.tag }
        handleTagClick={ this.props.handleTagClick }
        activeClass={ activeClass(this.props.tag) }
        imageSrc={ backgroundImage(this.props.tag) }
      />
    )
  }



}

export default TagHOC



// WEBPACK FOOTER //
// ./src/components/TagHOC.js